import type { MapDataPayload, MapState } from '../../types/map';

export const SET_MAP_DATA = 'SET_MAP_DATA' as const;
export const SET_MAP_DISPLAY = 'SET_MAP_DISPLAY' as const;

export const setMapData = (data: MapDataPayload) => {
    return {
        type: SET_MAP_DATA,
        payload: data
    }
};

export const setMapDisplay = (display: boolean) => {
    return {
        type: SET_MAP_DISPLAY,
        payload: display ? 'path' as const : '' as const
    }
};

export type MapAction =
    | ReturnType<typeof setMapData>
    | ReturnType<typeof setMapDisplay>;
